import React, { useEffect } from 'react';

// Stripe 決済(Checkout)/契約管理(Billing Portal)の完了後の着地ページ。
//
// アプリは success_url / cancel_url / return_url に return_to(= アプリのカスタムスキーム
// ninpath://subscription 等)を付けて Stripe に渡す。Stripe は https 必須のためまずこの
// https ページへ戻り、ここで return_to へリダイレクトする。すると、アプリが決済ブラウザを
// 開くのに使った WebBrowser.openAuthSessionAsync が「カスタムスキームへの遷移」を検知して
// 認証セッションを閉じ、アプリへ自動復帰する。
//
// return_to が無い場合も Stripe からの戻り(return_to を付けない経路)なので、既定の
// 戻り先としてアプリのサブスクリプションページ(DEFAULT_DEST)を開く。
//
// ディープリンクが発火しない環境(一部のアプリ内ブラウザ等)では画面遷移が起きないだけ
// なので、その場合に備えて誘導文言と手動の「アプリに戻る」ボタンを常に表示しておき、
// 発火は描画後に少し遅らせて、この案内が先に見えるようにする。
//
// なお /subscription は Universal Link (AASA) にも登録されており、LP(passport-light.html)の
// アプリ内加入ボタン等からのアクセスは OS がアプリを直接開くため、この Web ページには届かない。
//
// return_to はユーザー制御のクエリ文字列なので、アプリのカスタムスキームだけを許可する。
// javascript: や data:、http(s) 等をそのまま遷移/リンクさせると、ninpath.com オリジンでの
// XSS や任意サイトへのオープンリダイレクトに繋がるため、スキームを許可リストで検証し、
// 許可外・不正な URL は既定の戻り先に差し替える。
const ALLOWED_SCHEMES = ['ninpath:'];
const DEFAULT_DEST = 'ninpath://subscription';

const SubscriptionReturn = () => {
  const params = new URLSearchParams(window.location.search);
  const returnTo = params.get('return_to');
  const result = params.get('result'); // "success" | "cancel"(Checkout) / 無し(Portal)

  // 成否(result)をカスタムスキームへ引き継ぐ。アプリはこの result を読んで
  // 成功/キャンセルをユーザーに明示する。
  const buildDest = () => {
    const base = (() => {
      if (!returnTo) return DEFAULT_DEST;
      let scheme;
      try {
        scheme = new URL(returnTo).protocol;
      } catch (e) {
        return DEFAULT_DEST;
      }
      if (!ALLOWED_SCHEMES.includes(scheme)) return DEFAULT_DEST;
      return returnTo;
    })();
    if (!result) return base;
    const sep = base.indexOf('?') === -1 ? '?' : '&';
    return `${base}${sep}result=${encodeURIComponent(result)}`;
  };
  const dest = buildDest();

  useEffect(() => {
    // 履歴に残さず即バウンス。カスタムスキームへの遷移を openAuthSessionAsync が捕捉する。
    // ディープリンクが発火しない環境では何も起きないため、描画後に発火させて
    // 下の誘導文言・ボタンが先に表示された状態を保つ。
    const timer = window.setTimeout(() => {
      window.location.replace(dest);
    }, 100);
    return () => window.clearTimeout(timer);
  }, [dest]);

  return (
    <div
      style={{
        maxWidth: 420,
        margin: '80px auto',
        padding: 24,
        textAlign: 'center',
        fontFamily: 'sans-serif',
      }}
    >
      <h2 style={{ fontSize: 20, marginBottom: 12 }}>お手続きが完了しました</h2>
      <p style={{ color: '#666', lineHeight: 1.7, marginBottom: 20 }}>
        アプリに戻っています…
        <br />
        自動で戻らない場合は、下のボタンからお戻りください。
      </p>
      <a
        href={dest}
        style={{
          display: 'inline-block',
          background: '#D65358',
          color: '#fff',
          textDecoration: 'none',
          padding: '12px 24px',
          borderRadius: 24,
          fontWeight: 700,
        }}
      >
        アプリに戻る
      </a>
    </div>
  );
};

export default SubscriptionReturn;
